<template>
  <div>
    <vx-card :title="$t('registration_status')" class="mb-8" v-if="loaded === true">
      <vs-row vs-justify="center" v-if="showDashboardStatistics === true">
        <vs-col type="flex" vs-align="center" vs-w="12">
          <vs-table hover-flat v-if="records && records.length" :data="records">
            <template slot="thead">
              <vs-th v-text="$t('name')"></vs-th>
              <vs-th v-text="$t('count')"></vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr v-for="(tr, indextr) in data" :key="indextr">
                <vs-td v-text="$t(tr.title)"></vs-td>
                <vs-td v-text="tr.value"></vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-col>
      </vs-row>
      <vx-card v-else>
        <template slot="actions">
          <shared-dashboard-tab-nav></shared-dashboard-tab-nav>
        </template>
        <vs-row vs-justify="center">
          <vs-col type="flex" vs-align="center" vs-w="6" vs-lg="6" vs-sm="6" vs-xs="12">
            <router-link tag="a" :to="{ name: 'members', query: { from: $momentHelper.getCurrentDate(), to: $momentHelper.getCurrentDate() } }">
              <vs-card class="cardx">
                <div slot="header">
                  <h3>
                    {{ $t('new_member') }}
                  </h3>
                </div>
                <div>
                  <h3>&nbsp;{{ newMemberCount }}</h3>
                </div>
              </vs-card>
            </router-link>
            <vs-card class="cardx">
              <div slot="header">
                <h3>
                  {{ $t('members') }}
                </h3>
              </div>
              <div>
                <vs-row>
                    <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-lg="6" vs-sm="12">

                      <div class="vs-list">
                        <div class="vs-list--item">
                          <div class="list-titles">
                            <div class="vs-list--title">{{ $t('consultation_status') }}</div>
                          </div>
                        </div>
                        <div class="vs-list--item" v-for="(division, key) in divisions" v-bind:key="'division_' + key">
                          <div class="list-titles">
                            <div class="vs-list--subtitle">
                              <router-link :to="{ name: 'consultations.consultations', query: {division: division.name, from: $momentHelper.getCurrentDate()} }" tag="a">
                                {{ division.name }}
                              </router-link>
                            </div>
                          </div>
                          <div class="vs-list--slot">
                            <vs-chip>{{ division.consultations_count }}</vs-chip>
                          </div>
                        </div>
                      </div>

                    </vs-col>

                    <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-lg="6" vs-sm="12">

                      <div class="vs-list">
                        <div class="vs-list--item">
                          <div class="list-titles">
                            <div class="vs-list--title">{{ $t('processing_result') }}</div>
                          </div>
                        </div>
                        <div class="vs-list--item" v-for="(result, key) in results" v-bind:key="'result_' + key">
                          <div class="list-titles">
                            <div class="vs-list--subtitle">
                              <router-link :to="{ name: 'consultations.consultations', query: {resultName: result.name, from: $momentHelper.getCurrentDate()} }" tag="a">
                                {{ result.name }}
                              </router-link>
                            </div>
                          </div>
                          <div class="vs-list--slot">
                            <vs-chip>{{ result.consultations_count }}</vs-chip>
                          </div>
                        </div>
                      </div>

                    </vs-col>

                    <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-lg="6" vs-sm="12">

                      <div class="vs-list">
                        <div class="vs-list--item">
                          <div class="list-titles">
                            <div class="vs-list--title">{{ $t('custom_fields') }}</div>
                          </div>
                        </div>
                        <div class="vs-list--item" v-for="(memberCustomField, key) in memberCustomFields" v-bind:key="'memberCustomField_' + key">
                          <div class="list-titles">
                            <div class="vs-list--subtitle">
                              <router-link :to="{ name: 'consultations.consultations', query: {memberCustomField: memberCustomField.id, from: $momentHelper.getCurrentDate()} }" tag="a">
                                {{ memberCustomField.name }}
                              </router-link>

                            </div>
                          </div>
                          <div class="vs-list--slot">
                            <vs-chip>{{ memberCustomField.custom_field_values_count }}</vs-chip>
                          </div>
                        </div>
                      </div>

                    </vs-col>

                  </vs-row>
              </div>
            </vs-card>
          </vs-col>
          <vs-col type="flex" vs-align="center" vs-w="6" vs-lg="6" vs-sm="6" vs-xs="12">
            <router-link tag="a" :to="{ name: 'consultations.consultations', query: { from: $momentHelper.getCurrentDate(), to: $momentHelper.getCurrentDate() } }">
              <vs-card class="cardx">
                <div slot="header">
                  <h3>
                    {{ $t('new_consultation') }}
                  </h3>
                </div>
                <div>
                  <h3>&nbsp;{{ newConsultationCount }}</h3>
                </div>
              </vs-card>
            </router-link>
            <vs-card class="cardx">
              <div slot="header">
                <h3>
                  {{ $tc('consultation', 2) }}
                </h3>
              </div>
              <div>
                <vs-row vs-justify="center">

                    <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-lg="6" vs-sm="12">

                      <div class="vs-list">
                        <div class="vs-list--item">
                          <div class="list-titles">
                            <div class="vs-list--title">{{ $t('big') }}</div>
                          </div>
                        </div>
                        <div class="vs-list--item" v-for="(big, key) in bigs" v-bind:key="'big_' + key">
                          <div class="list-titles">
                            <div class="vs-list--subtitle">
                              <router-link :to="{ name: 'consultations.consultations', query: {big: big.id, from: $momentHelper.getCurrentDate()} }" tag="a">
                                {{ big.name }}
                              </router-link>
                            </div>
                          </div>
                          <div class="vs-list--slot">
                            <vs-chip>{{ big.consultations_count }}</vs-chip>
                          </div>
                        </div>
                      </div>

                    </vs-col>

                    <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-lg="6" vs-sm="12">

                      <div class="vs-list">
                        <div class="vs-list--item">
                          <div class="list-titles">
                            <div class="vs-list--title">{{ $t('small') }}</div>
                          </div>
                        </div>
                        <div class="vs-list--item" v-for="(small, key) in smalls" v-bind:key="'small_' + key">
                          <div class="list-titles">
                            <div class="vs-list--subtitle">
                              <router-link :to="{ name: 'consultations.consultations', query: {small: small.id, big: small.big_type_id, from: $momentHelper.getCurrentDate()} }" tag="a">
                                {{ small.name }}
                              </router-link>
                            </div>
                          </div>
                          <div class="vs-list--slot">
                            <vs-chip>{{ small.consultations_count }}</vs-chip>
                          </div>
                        </div>
                      </div>

                    </vs-col>

                    <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-lg="6" vs-sm="12" v-for="(consultationCustomField, key) in consultationCustomFields" v-bind:key="'consultationCustomFieldColumn_' + key">

                      <div class="vs-list">
                        <div class="vs-list--item">
                          <div class="list-titles">
                            <div class="vs-list--title">{{ consultationCustomField.name }}</div>
                          </div>
                          <div class="vs-list--slot">
                            <vs-chip>{{ consultationCustomField.custom_field_values_count }}</vs-chip>
                          </div>
                        </div>
                        <div class="vs-list--item" v-for="(option, key) in consultationCustomField.active_options" v-bind:key="'consultationCustomField_' + key">
                          <div class="list-titles">
                            <div class="vs-list--subtitle">
                              <router-link :to="{ name: 'consultations.consultations', query: {consultationCustomField: consultationCustomField.id, consultationCustomFieldValue: option.value, from: $momentHelper.getCurrentDate()} }" tag="a">
                                {{ option.value }}
                              </router-link>
                            </div>
                          </div>
                          <div class="vs-list--slot">
                            <vs-chip>{{ option.custom_field_values_count }}</vs-chip>
                          </div>
                        </div>
                      </div>

                    </vs-col>

                  </vs-row>
              </div>
            </vs-card>
          </vs-col>
        </vs-row>
      </vx-card>
    </vx-card>
  </div>
</template>

<script>
import SharedDashboardTabNav from '@/views/Shared/Dashboard/TabNav'
import Dashboard from '@/models/Dashboard'

import DoughnutChart from '@/components/DoughnutChart.vue'

export default {
  name: 'User.Dashboard.RegistrationStatus',
  components: {
    SharedDashboardTabNav,
    DoughnutChart
  },
  data () {
    return {
      initialPage: typeof this.$route.query.page !== 'undefined' && this.$route.query.page > 0 ? parseInt(this.$route.query.page) : 1,
      loaded: false,
      showDashboardStatistics: false,
      newMemberCount: 0,
      newConsultationCount: 0,
      divisions: {},
      results: {},
      bigs: {},
      smalls: {},
      memberCustomFields: {},
      consultationCustomFields: {},
      totalIncoming: 0,
      hangupWithoutIvrStep: 0
    }
  },
  mounted () {
    this.loadRegistrationStatus()
  },
  methods: {
    async loadRegistrationStatus () {
      const res = await Dashboard.all()

      this.showDashboardStatistics = res.data.showDashboardStatistics
      this.loaded = true
      if (this.showDashboardStatistics === false) {
        this.newMemberCount = res.data.newMemberCount
        this.newConsultationCount = res.data.newConsultationCount
        this.divisions = res.data.divisions
        this.results = res.data.results
        this.bigs = res.data.bigs
        this.smalls = res.data.smalls
        this.memberCustomFields = res.data.memberCustomFields
        this.consultationCustomFields = res.data.consultationCustomFields
      } else {
        this.records = res.data.records
        this.totalIncoming = res.data.totalIncoming
        this.hangupWithoutIvrStep = res.data.hangupWithoutIvrStep
      }
    }
  }
}
</script>

<style scoped>
.cardx {
  margin: 15px;
}
.con-vs-card {
  width: auto;
}
</style>
